import BlockCardConfirmationButton from './BlockCardConfirmationButton';

export default BlockCardConfirmationButton;